// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconVideo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="currentColor">
            <path
                d="M116.5,1136.4375 L116.5,1142.0625 C116.5,1142.58027 116.080274,1143 115.5625,1143 L109.9375,1143 C109.419727,1143 109,1142.58027 109,1142.0625 L109,1136.4375 C109,1135.91973 109.419727,1135.5 109.9375,1135.5 L115.5625,1135.5 C116.080078,1135.5 116.5,1135.91973 116.5,1136.4375 Z M120.25,1136.74023 L120.25,1141.75781 C120.25,1142.25586 119.680274,1142.54668 119.26582,1142.26152 L117.125,1140.78711 L117.125,1137.71289 L119.265625,1136.23711 C119.681641,1135.95176 120.25,1136.24414 120.25,1136.74023 Z"
                transform="translate(-109 -1135)"
            />
        </svg>
    );
};

export default React.memo(IconVideo);
